import { render } from "./ProfileGeneralInfo.vue?vue&type=template&id=dfdd955e&scoped=true"
import script from "./ProfileGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProfileGeneralInfo.vue?vue&type=script&lang=js"

import "./ProfileGeneralInfo.vue?vue&type=style&index=0&id=dfdd955e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfdd955e"]])

export default __exports__